import type { ConditionDetailType } from '../../types/condition';

const sortDetailOrdinary = (a: ConditionDetailType, b: ConditionDetailType): number => {
  // https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
  const customerA = a.customer?.toUpperCase() ?? ''; // 大文字と小文字を無視する
  const customerB = b.customer?.toUpperCase() ?? ''; // 大文字と小文字を無視する
  const customer1A = a.customer1?.toUpperCase() ?? ''; // 大文字と小文字を無視する
  const customer1B = b.customer1?.toUpperCase() ?? ''; // 大文字と小文字を無視する
  const deliveryLocationA = a.deliveryLocation?.toUpperCase() ?? ''; // 大文字と小文字を無視する
  const deliveryLocationB = b.deliveryLocation?.toUpperCase() ?? ''; // 大文字と小文字を無視する
  if (customerA !== '' && customerB === '') {
    return -1;
  }
  if (customerA === '' && customerB !== '') {
    return 1;
  }
  if (customerA < customerB) {
    return -1;
  }
  if (customerA > customerB) {
    return 1;
  }
  if (customer1A < customer1B) {
    return -1;
  }
  if (customer1A > customer1B) {
    return 1;
  }
  if (deliveryLocationA < deliveryLocationB) {
    return -1;
  }
  if (deliveryLocationA > deliveryLocationB) {
    return 1;
  }
  // names must be equal
  return 0;
};

export default sortDetailOrdinary;
